import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tagsService } from '../tags.service';
import { BaseCacheService } from './base-cache';

@Injectable({
  providedIn: 'root'
})
export class TagsCacheService extends BaseCacheService<any> {
  constructor(private tagsService: tagsService) {
    super();
  }

  protected fetchApiData(): Observable<any[]> {
    return this.tagsService.get();
  }
}
